module.exports = require("@bechtel/client-assets/dist/images/pf-unauthorized-logo.svg");